import { render, staticRenderFns } from "./WhiteboardCanvas.vue?vue&type=template&id=d03411ae&scoped=true&"
import script from "./WhiteboardCanvas.vue?vue&type=script&lang=js&"
export * from "./WhiteboardCanvas.vue?vue&type=script&lang=js&"
import style0 from "./WhiteboardCanvas.vue?vue&type=style&index=0&id=d03411ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03411ae",
  null
  
)

export default component.exports